import React from "react";
import { Link } from "react-router-dom";
import { Shield, CheckCircle2, RefreshCw, Phone } from "lucide-react";

const PARTNER_LINK_CLASS = "text-sm font-medium hover:text-[#b89a6d] transition-colors";
const BADGE_ITEM_CLASS = "flex items-center gap-2 text-[#a09186] text-xs";

export const FooterDisclaimer = () => (
  <div className="mt-12 pt-8 border-t border-[#f0d8d4]" data-testid="footer-fda-disclaimer">
    <div className="max-w-4xl mx-auto bg-amber-50 border border-amber-300 rounded-xl p-5">
      <p className="text-[#5a4a40] text-xs text-center leading-relaxed">
        <strong className="text-amber-800 uppercase tracking-wide">FDA Disclaimer · Research Use Only</strong>
        <br className="block mt-1" />
        Products on this website are research chemicals supplied for in-vitro laboratory research purposes only. They are <strong>not approved by the U.S. Food &amp; Drug Administration</strong> for any therapeutic, diagnostic, or human use, are not drugs, and are not dietary supplements.
        Nothing on this site has been evaluated by the FDA. Content is educational and is not intended to diagnose, treat, cure, or prevent any disease and is not medical advice. Consult a licensed healthcare professional before any wellness or aesthetic intervention.
      </p>
    </div>
  </div>
);

export const FooterPartners = () => (
  <div className="mt-8 pt-8 border-t border-[#f0d8d4]" data-testid="footer-trusted-partners">
    <div className="text-center mb-4">
      <span className="text-xs uppercase tracking-wider text-[#a09186] font-semibold">
        Educational Referral Partners
      </span>
    </div>
    <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10 text-[#7a6b62]">
      <Link to="/partners" data-testid="footer-partners-alphasync" className={PARTNER_LINK_CLASS}>
        AlphaSync Rx
      </Link>
      <span className="text-[#e8c5b8]">·</span>
      <Link to="/partners" data-testid="footer-partners-mydose" className={PARTNER_LINK_CLASS}>
        MyDose.ai
      </Link>
      <span className="text-[#e8c5b8]">·</span>
      <Link to="/compliance" data-testid="footer-partners-compliance" className={PARTNER_LINK_CLASS}>
        Compliance &amp; Regulatory
      </Link>
    </div>
  </div>
);

export const FooterTrustBadges = () => (
  <div className="mt-8 pt-8 border-t border-[#f0d8d4]">
    <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10">
      <div className={BADGE_ITEM_CLASS}>
        <Shield className="w-4 h-4 text-[#b89a6d]" />
        <span>SSL Secured</span>
      </div>
      <div className={BADGE_ITEM_CLASS}>
        <CheckCircle2 className="w-4 h-4 text-[#b89a6d]" />
        <span>Registered LLC — Hawaii</span>
      </div>
      <div className={BADGE_ITEM_CLASS}>
        <RefreshCw className="w-4 h-4 text-[#b89a6d]" />
        <span>30-Day Money-Back Guarantee</span>
      </div>
      <div className={BADGE_ITEM_CLASS}>
        <Phone className="w-4 h-4 text-[#b89a6d]" />
        <span>Real Customer Support</span>
      </div>
    </div>
  </div>
);

export const FooterCopyright = ({ year }) => (
  <div className="mt-8 pt-8 border-t border-[#f0d8d4]">
    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
      <p className="text-[#a09186] text-sm">
        © {year} PeptidesForMedSpas LLC. All rights reserved.
      </p>
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-[#a09186] text-sm">
        <Link to="/privacy" className="hover:text-[#b89a6d] transition-colors">Privacy</Link>
        <span className="hidden md:inline">|</span>
        <Link to="/terms" className="hover:text-[#b89a6d] transition-colors">Terms</Link>
        <span className="hidden md:inline">|</span>
        <Link to="/refund" className="hover:text-[#b89a6d] transition-colors">Refunds</Link>
        <span className="hidden md:inline">|</span>
        <Link to="/disclaimer" className="hover:text-[#b89a6d] transition-colors">Disclaimer</Link>
      </div>
    </div>
  </div>
);
